var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"faleConosco"}},[_c('Banner',{attrs:{"contents":_vm.banner}}),_c('Blocks',{attrs:{"contents":_vm.contents,"path":_vm.path},on:{"update:path":function($event){_vm.path=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }